import { Injectable }    from '@angular/core';
import { CanActivate } from '@angular/router';
import { ApiService } from './api.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
  
  constructor(private apiService: ApiService, private router: Router) {}
  
  canActivate() {
    return new Promise((resolve, reject) => {
      this.apiService.isAuthenticated().then(() => {
        resolve(true);
      }).catch((err) => {
        this.router.navigateByUrl('login');
        reject(false);
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/authguard.service.ts